const SvgCheckCircle = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667m-1.533 18.666-5.133-4.96 1.453-1.4 3.68 3.56L21.214 12l1.453 1.4z" />
  </svg>;
export default SvgCheckCircle;